
export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              MarineBioGroup
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              A marine biotechnology company developing biodegradable materials<br />
              free from microplastics for eco-friendly daily products.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#technology" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Technology</a></li>
              <li><a href="#products" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Products</a></li>
              <li><a href="#research" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Research</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">About Us</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +1-571-531-8278
              </p>
              <p className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                contact@marinebiogroup.com
              </p>
              <p className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                1108 Nueces St, Austin, TX 78701
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 MarineBioGroup. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
